// @ts-expect-error pure js
import { ETAT_OPTIONS } from "../../models/edl";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import styles from "./EdlEtatPills.module.css";

type EtatOption = { value: string; label: string };

const ETAT_CLASS: Record<string, string> = {
  "1": styles.neuf,
  "2": styles.good,
  "3": styles.medium,
  "4": styles.bad,
};

interface EdlEtatPillsProps {
  value?: string | number | null;
  onChange: (value: string) => void;
  label: string;
  /** Un second clic sur l'état sélectionné le désélectionne. */
  allowClear?: boolean;
  className?: string;
}

/** Choix de l'état (Neuf → Mauvais état) sous forme de pastilles colorées. */
export default function EdlEtatPills({
  value,
  onChange,
  label,
  allowClear = false,
  className,
}: EdlEtatPillsProps) {
  const current = value == null ? "" : String(value);
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={classnames(styles.group, className)}
    >
      {(ETAT_OPTIONS as EtatOption[]).map((option) => {
        const selected = option.value === current;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={classnames(
              styles.pill,
              ETAT_CLASS[option.value],
              selected && styles.selected,
            )}
            onClick={() => onChange(selected && allowClear ? "" : option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
